import React, { use, useEffect, useState } from "react";
import '../../../styles/Auth/return.css';
import { useNavigate } from "react-router-dom";
import { deleteData, getData, postData, putData } from '../../../webService/webservice.js';
import { toast } from "react-toastify";
const ReturnAddPage = () => {
    const navigate = useNavigate();
    const token = sessionStorage.getItem("sessionToken");
    const handleCancelReturn = () => {
        navigate('/sales-return');
    }
    const [invoices, setInvoices] = useState([]);
    const [selectedInvoice, setSelectedInvoice] = useState(null);

    const [returnItems, setReturnItems] = useState([]);

    const [note, setNote] = useState("");

    useEffect(() => {
        const token = sessionStorage.getItem("sessionToken");

        const fetchInvoices = async () => {
            try {
                const res = await getData("/invoices/invoices", {}, token);
                setInvoices(res?.data?.[0]?.paginatedResults || []);
            } catch {
                setInvoices([]);
            }
        };
        fetchInvoices();
    }, []);

    const handleInvoiceSelect = async (invoiceId) => {
        const invoice = invoices.find(i => i._id === invoiceId);
        if (!invoice) return;

        try {
            const res = await getData(`/invoices/invoice/${invoiceId}`, {}, token);
            const invoiceDetails = res?.data;
            if (!invoiceDetails) return;

            const preparedItems = invoiceDetails.items.map(item => ({
                _id: item._id,
                productId: item.productId,
                name: item.name,
                price: item.rate,
                originalQty: item.qty,
                returnQty: 0
            }));

            setReturnItems(preparedItems);
            setSelectedInvoice(invoiceDetails);
        } catch (err) {
            console.error("Error fetching invoice details", err);
            setReturnItems([]);
        }
    };

    const increaseReturnQty = (id, maxQty) => {
        setReturnItems(prev =>
            prev.map(item =>
                item._id === id
                    ? { ...item, returnQty: Math.min(item.returnQty + 1, maxQty) }
                    : item
            )
        );
    };


    const decreaseReturnQty = (id) => {
        setReturnItems(prev =>
            prev.map(item =>
                item._id === id
                    ? { ...item, returnQty: Math.max(item.returnQty - 1, 0) }
                    : item
            )
        );
    };

    const removeItem = (id) => {
        setReturnItems(prev => prev.filter(item => item._id !== id));
    };

    const totalReturnProducts = returnItems.filter(i => i.returnQty > 0).length;
    const totalReturnItems = returnItems.reduce((sum, i) => sum + i.returnQty, 0);
    const totalReturnAmount = returnItems.reduce((sum, i) => sum + (i.price * i.returnQty), 0);

    const handleAddReturn = async () => {

        const validItems = returnItems.filter(i => i.returnQty > 0);

        if (!selectedInvoice) {
            alert("Please select an invoice!");
            return;
        }

        if (validItems.length === 0) {
            alert("Please select at least 1 returned item.");
            return;
        }

        const payload = {
            invoiceId: selectedInvoice._id,
            remarks: note,
            items: validItems.map(i => ({
                productId: i.productId,
                qtyReturned: i.returnQty,
                rate: i.price
            }))
        };

        try {
            const res = await postData("salesreturns/", payload, token);
            if (res.status === 200 || res.status === 201) {
                toast.success("Sales Return Created Successfully!");
                setReturnItems([]);
                setSelectedInvoice(null);
                navigate("/sales-return");
                setNote("");
            }
        } catch (err) {
            console.log(err);
            toast.error("Failed to create return. Check console.");
        }
    };

    return (
        <div className="return-container">
            <h2>Add Sales Return</h2>
            <div className="return-top-inputs">
                <div className="return-input-group">
                    <label className="return-input-label">Invoice</label>
                    <select
                        value={selectedInvoice?._id || ""}
                        onChange={(e) => handleInvoiceSelect(e.target.value)}
                    >
                        <option value="">-- Select Invoice --</option>
                        {invoices.map(inv => (
                            <option key={inv._id} value={inv._id}>
                                {inv.invoiceNo}
                            </option>
                        ))}
                    </select>
                </div>
            </div>

            <div className="return-top">
                {/* Products Table */}

                <div className="product-box">
                    <table>
                        <thead>
                            <tr>
                                <th>Product/Service</th>
                                <th>Purchase Quantity</th>
                                <th>Return Quantity</th>
                                <th>Purchase Cost</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {returnItems.map((item, idx) => (
                                <tr key={item._id || idx}>
                                    {/* Product Info */}
                                    <td className="product-info">
                                        <img src={item.image} alt={item.name} />
                                        {item.name}
                                    </td>
                                    <td>{item.originalQty}</td>
                                    <td>
                                        <div className="qty-controls">
                                            <button
                                                type="button"
                                                onClick={() => decreaseReturnQty(item._id)}
                                                disabled={item.returnQty <= 0}
                                            >
                                                -
                                            </button>
                                            <span>{item.returnQty}</span>
                                            <button
                                                type="button"
                                                onClick={() => increaseReturnQty(item._id, item.originalQty)}
                                            >
                                                +
                                            </button>
                                        </div>
                                    </td>

                                    {/* Line Total */}
                                    <td>₹{item.price * item.returnQty}.00</td>

                                    {/* Delete Row */}
                                    <td>
                                        <button
                                            type="button"
                                            className="delete-btn"
                                            onClick={() => removeItem(item._id)}
                                        >
                                            🗑
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>

                    </table>
                </div>

                {/* Bill Summary */}
                <div className="summary-box">
                    <h2>Bill Summary</h2>
                    <div className="summary-row">
                        <span>Total products</span>
                        <span>{totalReturnProducts}</span>
                    </div>
                    <div className="summary-row">
                        <span>Total Items</span>
                        <span>{totalReturnItems}</span>
                    </div>
                    <div className="summary-row">
                        <span>Total amount</span>
                        <span>₹{totalReturnAmount.toFixed(2)}</span>
                    </div>
                </div>
            </div>

            {/* Note Section */}
            <div className="note-box">
                <label>Note</label>
                <textarea placeholder="Type Description"></textarea>
                <div className="note-actions">
                    <button className="cancel-btn" onClick={handleCancelReturn}>Cancel</button>
                    <button className="return-btn" onClick={handleAddReturn}>add Return</button>
                </div>
            </div>
        </div>
    );
};

export default ReturnAddPage;
